import { documentsConstants } from "../constants";
import { documentsRequestsAsync } from "../../services";

export const documentsActionsAsync = {};

documentsActionsAsync.DownloadDocumentAsync = async (data) => {
  return await documentsRequestsAsync.DownloadDocumentAsync(data)

};